const pad = (n) => String(n).padStart(2, '0');
const stamp = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;

export const toIsoDate = (value) => {
  if (value === null || value === undefined || value === '') return '';

  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? ''
      : stamp(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  const text = String(value).trim();
  if (!text) return '';

  // Drop the time half, whether it is separated by a space or a T.
  const [datePart] = text.split(/[ T]/);

  // Already ISO.
  let m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(datePart);
  if (m) return stamp(m[1], m[2], m[3]);

  // Slash-separated. The API sends month/day/year, but a first number above 12
  // can only be a day, so honour that rather than producing a bogus month.
  m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(datePart);
  if (m) {
    const [, a, b, y] = m;
    return Number(a) > 12 && Number(b) <= 12
      ? stamp(y, b, a)   // day/month/year
      : stamp(y, a, b);  // month/day/year
  }

  // Dash or dot separated day-first, e.g. 01-03-2026 or 01.03.2026.
  m = /^(\d{1,2})[-.](\d{1,2})[-.](\d{4})$/.exec(datePart);
  if (m) return stamp(m[3], m[2], m[1]);

  // Unknown shape — show what came in rather than blanking real data.
  return text;
};

export default toIsoDate;